import { render, staticRenderFns } from "./myTeamInvite.vue?vue&type=template&id=b97aa144&scoped=true&"
import script from "./myTeamInvite.vue?vue&type=script&lang=js&"
export * from "./myTeamInvite.vue?vue&type=script&lang=js&"
import style0 from "./myTeamInvite.vue?vue&type=style&index=0&id=b97aa144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97aa144",
  null
  
)

export default component.exports